/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentSyntheticSleepStatuses } from './equipment-synthetic-sleep-statuses';
import { EquipmentSyntheticSleepPhases } from './equipment-synthetic-sleep-phases';


export interface EquipmentSyntheticSleepOperationResponse { 
    status?: EquipmentSyntheticSleepStatuses;
    phase?: EquipmentSyntheticSleepPhases;
    isOverdue?: boolean;
    failureReason?: string | null;
    savedAtUtc?: string;
    activatedAtUtc?: string | null;
    restoreRequestedAtUtc?: string | null;
    failedAtUtc?: string | null;
}



